import React from 'react';
import {formatDateAndTime} from '../../../../../../../../design/1/js/lib/formatData';
import AnswerType from '../../../lib/AnswerType';
import './index.scss';
import nl2br from '../../../lib/nl2br';
import Icon, {IconName} from "../../../../../../../../design/1/js/templates/atoms/icon";

interface ConversationAnswerProps {
    answer: AnswerType;
    inboxId: int;
    isClient?: boolean;
    getAttachmentAction: string;
}

const ConversationAnswer = ({
    answer, inboxId, isClient, getAttachmentAction
}: ConversationAnswerProps) => {
    const baseClassName = 'm-conversation-answer';

    const messageIsFromOther = (isClient === answer.fromMPK);
    const isUnread = !answer.read && messageIsFromOther;
    const hasAttachments = answer.attachments.length > 0;

    return (
        <div className={`${baseClassName} ${messageIsFromOther && '-fromOther'} ${isUnread && '-unread'}`} role="presentation">
            <div className={`${baseClassName}__content`}>
                <div className={`${baseClassName}__infoWrapper col-12`}>
                    <div className={`${baseClassName}__info`}>
                        {formatDateAndTime(new Date(answer.date))}
                    </div>
                    <div className={`${baseClassName}__info`}>
                        {answer.sender}
                    </div>
                </div>
                <div className={`${baseClassName}__panel`}>
                    <p>{nl2br(answer.text)}</p>
                </div>
            </div>
            { hasAttachments && (
                <div className={`${baseClassName}__attachments`}>
                    {
                        answer.attachments.map((attachment, index) => {
                            const link = new URL(getAttachmentAction, document.baseURI);
                            link.searchParams.append('attachmentId', attachment.id.toString());
                            link.searchParams.append('inboxId', inboxId.toString());

                            const isPDF = attachment.fileName.toLowerCase().endsWith('.pdf');
                            return (
                                <a className={`${baseClassName}__attachment ${isPDF && '-isPDF'}`} href={link.toString()} download key={`attachment-${index.toString()}`}>
                                    {isPDF && (
                                        <div className={`${baseClassName}__pdfAttachment`}>
                                            <Icon name={IconName.PDF} className={`${baseClassName}__pdfIcon`} />
                                            <span className={`${baseClassName}__pdfName`}>{attachment.fileName}</span>
                                        </div>
                                    )}
                                    {!isPDF && (
                                        <img src={link.toString()} alt={attachment.fileName}/>
                                    )}
                                </a>
                            );
                        })
                    }
                </div>
            )}
        </div>
    );
};

ConversationAnswer.defaultProps = {
    isClient: false,
    markRead: undefined,
};

export default ConversationAnswer;
